import { useQuery } from "@tanstack/react-query";

import { useSupabase } from "@/auth/SupabaseProvider";

import { apiFetch } from "./client";

/**
 * Memo picker feed for the `/run` page's Analyst + Intake Validator
 * cards (issue #571). Wraps the orchestrator's `GET /api/memos` list
 * endpoint — see `services/orchestrator/src/routes/memos.ts` for the
 * response shape and pagination posture.
 */

export type MemoValidationStatus =
  | "pending"
  | "validated"
  | "flagged"
  | "incomplete";

export interface MemoPickerRow {
  id: string;
  shortId: string;
  validationStatus: MemoValidationStatus;
  clientId: string | null;
  clientName: string | null;
  clientCompany: string | null;
  createdAt: string;
}

export interface MemosListResponse {
  items: MemoPickerRow[];
}

/** List the most recent 50 memos for the picker dropdown. Cached until
 *  a job dispatch invalidates — the operator can re-open the picker
 *  after a dispatch to grab a different memo without a full refresh. */
export function useMemos() {
  const { client } = useSupabase();
  return useQuery({
    queryKey: ["memos"],
    queryFn: ({ signal }) =>
      apiFetch<MemosListResponse>(client, "/api/memos", { signal }),
  });
}
